import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  AuthService,
  GlobalMessageService,
  WindowRef,
  AuthStorageService,
  UserIdService,
  StateWithClientAuth,
  AuthActions,
  AuthToken,
  OCC_USER_ID_CURRENT,
  OccEndpointsService,
} from '@spartacus/core';
import { LoginFormComponent, LoginFormComponentService } from '@spartacus/user/account/components';
import { KnBrAuthRedirectService } from '../services/kn-br-auth-redirect.service';
import { Auth0Service } from '../services/knbr-new-auth0.service';
import { HttpClient } from '@angular/common/http';
import { KNBR_GET_SPARTACUS_TOKEN_FROM_AUTH0_TOKEN } from 'src/constants/api.endpoints.constant';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'knbr-new-auth-sso',
  templateUrl: './knbr-new-auth0-sso.component.html',
  standalone: false,
})
export class KnbrNewAuth0SsoComponent extends LoginFormComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  constructor(
    protected auth: AuthService,
    protected globalMessageService: GlobalMessageService,
    protected fb: FormBuilder,
    protected winRef: WindowRef,
    protected activatedRoute: ActivatedRoute,
    protected knBrAuthRedirectService: KnBrAuthRedirectService,
    protected authStorageService: AuthStorageService,
    protected userIdService: UserIdService,
    protected loginFormComponentService: LoginFormComponentService,
    protected store: Store<StateWithClientAuth>,
    protected newAuth0Service: Auth0Service,
    protected endPointService: OccEndpointsService,
    protected httpClient: HttpClient
  ) {
    super(loginFormComponentService);
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(async (params) => {
      if (params && params.code) {

        const tokenResponse = await this.newAuth0Service.exchangeCodeForTokens(params.code);
        const expiryDate = new Date(Date.now() + tokenResponse.expires_in * 1000);

        let token: AuthToken = {
          access_token: tokenResponse.access_token,
          refresh_token: tokenResponse.refresh_token || '',
          expires_at: expiryDate.toJSON(),
          granted_scopes: tokenResponse.scope ? tokenResponse.scope.split(' ') : [],
          access_token_stored_at: '',
          token_type: tokenResponse.token_type || 'Bearer',
        };

        const payload = {access_token : tokenResponse.access_token }

        const occUrl = this.endPointService.buildUrl(KNBR_GET_SPARTACUS_TOKEN_FROM_AUTH0_TOKEN);
        this.httpClient.post(occUrl, payload).pipe(takeUntil(this.destroy$)).subscribe({ next:(response:any) => {
          token = response;
          this.authStorageService.setToken(token as AuthToken);
        this.userIdService.setUserId(OCC_USER_ID_CURRENT);
        this.store.dispatch(new AuthActions.Login());
        this.knBrAuthRedirectService.redirect();
        }, error: (error) => {
          console.log('Error while exchanging Auth0 token for Spartacus token:', error);
          this.newAuth0Service.logOutTheUser();
        }
        })

      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
